import { Component, OnDestroy, OnInit } from '@angular/core';
import { User, VerifiedStatus } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { AppMessagingService } from '../../../core/services/app-messaging.service';
import { ChickenTestDialogService } from '../../shared/dialogs/chicken-test-dialog/chicken-test-dialog.service';

@Component({
  selector: 'app-customer-basic-info',
  templateUrl: './customer-basic-info.component.html',
  styleUrls: ['./customer-basic-info.component.scss'],
})
export class CustomerBasicInfoComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  user: User;
  subs: Subscription[] = [];

  constructor(
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private chickenTestDialog: ChickenTestDialogService,
  ) {
    this.user = this.userDAO.getCurrentUser();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  onUserInfoSave(user: Partial<User>): void {
    if (
      (user.firstName !== this.user.firstName ||
        user.lastName !== this.user.lastName) &&
      this.user.verifiedStatus !== VerifiedStatus.REQUIRES_INPUT
    ) {
      const chickenSub = this.chickenTestDialog
        .open(
          `Changing your first or last name will require you to re-verify your identity. This means that you will need to provide evidence and documentation to authenticate your new identity, ensuring that the name change is accurately reflected in official records and identification documents.`,
          'Yes, continue',
          'Cancel',
          35,
          null,
          'Identity re-verification required',
          false,
          'Would you still like to continue?',
          true,
        )
        .subscribe((save) => {
          if (save) {
            user.verificationSessionId = null;
            user.verifiedStatus = VerifiedStatus.REQUIRES_INPUT;
            this.saveUser(user);
          }
        });
      this.subs.push(chickenSub);
    } else {
      this.saveUser(user);
    }
  }

  saveUser(user: Partial<User>) {
    const sub = this.userDAO
      .updateFromPartial(this.user.id, user)
      .subscribe((data) => {
        this.appMessagingService.openSnack('User Info Updated.');
      });
    this.subs.push(sub);
  }
}
